export { default as client } from './client';
export { NetworkStatus } from '@apollo/client';
export { graphql } from '@apollo/client/react/hoc';

/* eslint-disable */
export function compose(...funcs) {
  const functions = funcs.reverse();
  return function(...args) {
    const [firstFunction, ...restFunctions] = functions;
    let result = firstFunction.apply(null, args);
    restFunctions.forEach(fnc => {
      result = fnc.call(null, result);
    });
    return result;
  };
}
